export enum MachineType {
  NONE = 'NONE',
  VERSATILE = 'VERSATILE',
  ESSENTIAL = 'ESSENTIAL',
  SPEED = 'SPEED',
  SOUL = 'SOUL',
  ZITRUX = 'ZITRUX'
}
